import React from "react";
import "./ConsultationSectionBSD.scss";
import agentPhoto from "./Reza.jpeg";

/**
 * ConsultationSectionBSD
 * Layout 2 band bersusun (sesuai wireframe): band atas warna navy berisi
 * heading + deskripsi, band bawah lebih terang berisi foto agent (kiri)
 * + nama/jobtitle (kanan) dan CTA WhatsApp. Warna diambil langsung dari
 * logo BSD City (navy #1D2D82 & oranye #F17E21).
 *
 * Contoh pemakaian:
 * <ConsultationSectionBSD
 *   agentName="Albert"
 *   agentPhoto="/assets/agents/albert.jpg"
 *   projectName="BSD City"
 *   whatsappNumber="62812806111"
 * />
 */
const ConsultationSectionBSD = ({
  agentName = "Reza Alhadithia",
  agentRole = "Marketing Agent",
  projectName = "BSD City",
  title,
  paragraphs,
  whatsappNumber = "6281319499502",
  whatsappMessage,
  ctaLabel = "Hubungi via WhatsApp",
}) => {
  const resolvedTitle =
    title || `Cari Tahu Lebih Dulu Soal Hunian ${projectName}`;

  const resolvedParagraphs = paragraphs || [
    `${projectName} punya banyak pilihan hunian dari berbagai cluster dan tipe, dan kadang itu bikin bingung mana yang paling cocok. ${agentName} bisa bantu breakdown pilihannya satu-satu, mulai dari lokasi, harga, sampai skema cicilan yang paling ringan buat Anda.`,
    `Nggak perlu buru-buru mutusin. Ceritain dulu kebutuhan dan budget Anda ke ${agentName}, nanti direkomendasiin unit yang paling pas. Semuanya gratis, tanpa ada biaya konsultasi.`,
  ];

  const resolvedMessage =
    whatsappMessage ||
    `Halo ${agentName}, saya ingin konsultasi seputar properti ${projectName}`;

  const waLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    resolvedMessage,
  )}`;

  return (
    <section className="consultation-bsd">
      <div className="consultation-bsd__container">
        <div className="consultation-bsd__card">
          <div className="consultation-bsd__top">
            <h2 className="consultation-bsd__title">{resolvedTitle}</h2>
            {resolvedParagraphs.map((paragraph, index) => (
              <p className="consultation-bsd__desc" key={index}>
                {paragraph}
              </p>
            ))}
          </div>

          <div className="consultation-bsd__bottom">
            <div className="consultation-bsd__agent">
              <div className="consultation-bsd__photo-ring">
                <img src={agentPhoto} alt={agentName} />
              </div>
              <div className="consultation-bsd__agent-info">
                <p className="consultation-bsd__agent-name">{agentName}</p>
                <p className="consultation-bsd__agent-role">{agentRole}</p>
              </div>
            </div>

            <a
              className="consultation-bsd__cta"
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-.826 1.68l-1.293.646a11.05 11.05 0 005.516 5.516l.646-1.293a1.5 1.5 0 011.68-.826l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z" />
              </svg>
              {ctaLabel}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSectionBSD;
